/**
 * Query-string parameter names recognised by the course landing page.
 * Referenced by both the middleware (which decides whether to switch to the
 * per-user SSR variant) and the page route that reads the values.
 */
export enum CourseAccessQueryParam {
    PASSWORD = 'password',
    X_COURSE_CONTROL_ID = 'xCourseControlId',
}

/**
 * The four `courseAccessRestriction` values returned in the GraphQL
 * `ACCESS_RESTRICTED` error extension. Mirrors the union in
 * api-platform-graphql/src/schema/course/course-access.types.ts.
 */
export enum CourseAccessRestriction {
    PASSWORD_PROTECTED = 'PASSWORD_PROTECTED',
    INVITE_ONLY = 'INVITE_ONLY',
    UNAVAILABLE = 'UNAVAILABLE',
    UNAVAILABLE_IN_YOUR_ORGANIZATION = 'UNAVAILABLE_IN_YOUR_ORGANIZATION',
}

/**
 * Public route shown to organization users when a course is not in their
 * Udemy Business content collection. Path is locale-agnostic; callers
 * prefix the current `lang` segment.
 */
export const ORGANIZATION_COURSE_NOT_AVAILABLE_PATH = '/organization/course-not-available';
